/* ============================================================
   HOFMAN ZAAIZADEN - hofman.js
   Geladen met defer - DOM is gegarandeerd klaar
   ============================================================ */
(function () {
  'use strict';

  /* ----------------------------------------------------------
     HELPERS
  ---------------------------------------------------------- */
  function qs(sel, ctx)  { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }
  function euro(cents)   { return '\u20ac' + (cents / 100).toFixed(2).replace('.', ','); }
  function esc(s)        { return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }

  /* ----------------------------------------------------------
     STICKY HEADER
  ---------------------------------------------------------- */
  var header = qs('#header');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-stuck', window.scrollY > 8); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ----------------------------------------------------------
     EXPANDABLE SEARCH
  ---------------------------------------------------------- */
  var searchToggle = qs('#searchToggle');
  var searchPanel  = qs('#searchPanel');
  var searchClose  = qs('#searchClose');
  var searchInput  = qs('#searchPanelInput');

  function openSearch() {
    if (!searchPanel) return;
    searchPanel.classList.add('is-open');
    searchPanel.setAttribute('aria-hidden', 'false');
    if (searchToggle) searchToggle.setAttribute('aria-expanded', 'true');
    if (searchInput) setTimeout(function () { searchInput.focus(); }, 60);
  }
  function closeSearch() {
    if (!searchPanel) return;
    searchPanel.classList.remove('is-open');
    searchPanel.setAttribute('aria-hidden', 'true');
    if (searchToggle) {
      searchToggle.setAttribute('aria-expanded', 'false');
      searchToggle.focus();
    }
  }
  if (searchToggle) {
    searchToggle.addEventListener('click', function () {
      if (searchPanel.classList.contains('is-open')) { closeSearch(); }
      else { openSearch(); }
    });
  }
  if (searchClose) searchClose.addEventListener('click', closeSearch);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && searchPanel && searchPanel.classList.contains('is-open')) closeSearch();
  });

  /* ----------------------------------------------------------
     MEGA MENU
     Trigger: button met data-mega-id="N" in .nav
     Panel:   div.mega met id="mega-N" in #megaWrap
  ---------------------------------------------------------- */
  var megaTriggers = qsa('[data-mega-id]');
  var openMegaId   = null;
  var closeTimer   = null;  // vertraging voorkomt knipperen bij hover gap

  function getMegaPanel(id) { return qs('#mega-' + id); }
  function getMegaTrig(id)  { return qs('[data-mega-id="' + id + '"]'); }

  function cancelClose() {
    if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
  }

  function openMegaPanel(id) {
    cancelClose();
    // Sluit eventueel ander open panel direct (geen vertraging)
    if (openMegaId !== null && openMegaId !== id) {
      var oldPanel = getMegaPanel(openMegaId);
      var oldTrig  = getMegaTrig(openMegaId);
      if (oldPanel) { oldPanel.classList.remove('is-open'); oldPanel.setAttribute('aria-hidden', 'true'); }
      if (oldTrig)  { oldTrig.setAttribute('aria-expanded', 'false'); }
      openMegaId = null;
    }
    var panel = getMegaPanel(id);
    var trig  = getMegaTrig(id);
    if (!panel || !trig) return;
    trig.setAttribute('aria-expanded', 'true');
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    openMegaId = id;
  }

  function closeMegaPanel() {
    if (openMegaId === null) return;
    var panel = getMegaPanel(openMegaId);
    var trig  = getMegaTrig(openMegaId);
    if (panel) { panel.classList.remove('is-open'); panel.setAttribute('aria-hidden', 'true'); }
    if (trig)  { trig.setAttribute('aria-expanded', 'false'); }
    openMegaId = null;
  }

  function scheduleClose() {
    cancelClose();
    closeTimer = setTimeout(closeMegaPanel, 120);
  }

  megaTriggers.forEach(function (trig) {
    var id = trig.getAttribute('data-mega-id');
    trig.addEventListener('mouseenter', function () { openMegaPanel(id); });
    trig.addEventListener('mouseleave', function (e) {
      // Niet sluiten als muis naar het panel of megaWrap gaat
      var panel = getMegaPanel(id);
      var wrap  = qs('#megaWrap');
      var dest  = e.relatedTarget;
      if ((panel && (panel === dest || panel.contains(dest))) ||
          (wrap  && (wrap  === dest || wrap.contains(dest)))) {
        cancelClose(); return;
      }
      scheduleClose();
    });
    // klik navigeert nu naar de categoriepagina (het is een <a>); hover opent het megamenu
  });

  // Header mouseleave: niet sluiten als muis naar megaWrap gaat
  var headerEl = qs('#header');
  if (headerEl) {
    headerEl.addEventListener('mouseleave', function (e) {
      var wrap = qs('#megaWrap');
      var dest = e.relatedTarget;
      if (wrap && (wrap === dest || wrap.contains(dest))) {
        cancelClose(); return;
      }
      scheduleClose();
    });
  }

  // Panel: openhouden als muis erboven is
  qsa('.mega').forEach(function (panel) {
    panel.addEventListener('mouseenter', cancelClose);
    panel.addEventListener('mouseleave', function (e) {
      var hdr  = qs('#header');
      var dest = e.relatedTarget;
      if (hdr && (hdr === dest || hdr.contains(dest))) {
        cancelClose(); return;
      }
      scheduleClose();
    });
  });

  // MegaWrap als brug tussen header en panel
  var megaWrapEl = qs('#megaWrap');
  if (megaWrapEl) {
    megaWrapEl.addEventListener('mouseenter', cancelClose);
    megaWrapEl.addEventListener('mouseleave', scheduleClose);
  }

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeMegaPanel(); closeMobileNav(); } });

  /* ----------------------------------------------------------
     MOBILE MENU
  ---------------------------------------------------------- */
  var mobileMenuBtn  = qs('#mobileMenuBtn');
  var mobileNav      = qs('#mobileNav');
  var mobileNavClose = qs('#mobileNavClose');


  function openMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.add('is-open');
    mobileNav.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
  }
  function closeMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.remove('is-open');
    mobileNav.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    document.body.style.overflow = '';
  }

  if (mobileMenuBtn) mobileMenuBtn.addEventListener('click', openMobileNav);
  if (mobileNavClose) mobileNavClose.addEventListener('click', closeMobileNav);
  if (mobileNav) mobileNav.addEventListener('click', function (e) {
    if (e.target === mobileNav) closeMobileNav();
  });

  qsa('.mobile-nav__parent').forEach(function (btn) {
    var sub = btn.nextElementSibling;
    if (!sub) return;
    btn.addEventListener('click', function () {
      var isOpen = btn.getAttribute('aria-expanded') === 'true';
      qsa('.mobile-nav__parent[aria-expanded="true"]').forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
        if (b.nextElementSibling) b.nextElementSibling.hidden = true;
      });
      btn.setAttribute('aria-expanded', String(!isOpen));
      sub.hidden = isOpen;
    });
  });

  /* ----------------------------------------------------------
     TOAST
  ---------------------------------------------------------- */
  var toastEl   = qs('#toast');
  var toastText = qs('#toastText');
  var toastTmr;

  function showToast(msg) {
    if (!toastEl) return;
    if (toastText) toastText.textContent = msg;
    toastEl.classList.add('is-on');
    clearTimeout(toastTmr);
    toastTmr = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2600);
  }

  /* ----------------------------------------------------------
     CART DRAWER
     Btw-opbouw (26 okt 2026): prijzen in Shopify zijn excl. btw.
     De drawer toont subtotaal excl., verzending excl., btw 21% en totaal incl.
     Verzendkosten en btw-percentage komen uit window.hofmanSettings (theme.liquid).
  ---------------------------------------------------------- */
  var cartEl       = qs('#cart');
  var cartScrim    = qs('#scrim');
  var cartItems    = qs('#cartItems');
  var cartFoot     = qs('#cartFoot');
  var cartSub      = qs('#cartSub');
  var cartShipCost = qs('#cartShipCost');
  var cartTax      = qs('#cartTax');
  var cartTotal    = qs('#cartTotal');
  var cartShip     = qs('#cartShip');
  var cartBar      = qs('#cartBar');
  var cartCount    = qs('#cartCount');
  var settings     = window.hofmanSettings || {};
  var FREE         = settings.freeShippingThreshold || 50;
  var SHIP_CENTS   = (typeof settings.shippingCents === 'number') ? settings.shippingCents : 574;
  var VAT_RATE     = (typeof settings.vatRate === 'number') ? settings.vatRate : 0.21;

  function inclVat(cents) { return Math.round(cents * (1 + VAT_RATE)); }

  function openCart()  {
    if (!cartEl) return;
    cartEl.classList.add('is-open');
    if (cartScrim) cartScrim.classList.add('is-open');
    cartEl.setAttribute('aria-hidden', 'false');
    refreshCart();
  }
  function closeCart() {
    if (!cartEl) return;
    cartEl.classList.remove('is-open');
    if (cartScrim) cartScrim.classList.remove('is-open');
    cartEl.setAttribute('aria-hidden', 'true');
  }

  var cartBtn   = qs('#cartBtn');
  var cartClose = qs('#cartClose');
  if (cartBtn)   cartBtn.addEventListener('click', openCart);
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartScrim) cartScrim.addEventListener('click', closeCart);

  function refreshCart() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function (e) { console.error('Cart error:', e); });
  }

  function renderCart(cart) {
    if (cartCount) {
      cartCount.textContent = cart.item_count;
      cartCount.classList.toggle('is-visible', cart.item_count > 0);
    }
    if (!cartItems) return;

    if (!cart.item_count) {
      cartItems.innerHTML = '<div class="cart__empty"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"><use href="#i-bag"/></svg><p>Je winkelmand is nog leeg.<br>Ontdek onze populaire mengsels.</p></div>';
      if (cartFoot) cartFoot.hidden = true;
      return;
    }
    if (cartFoot) cartFoot.hidden = false;

    cartItems.innerHTML = cart.items.map(function (item) {
      var img = item.image ? '<img src="' + esc(item.image) + '" alt="' + esc(item.product_title) + '" loading="lazy">' : '<div class="ph"></div>';
      var linePrice = (typeof item.final_line_price === 'number') ? item.final_line_price : item.line_price;
      return '<div class="ci" data-key="' + item.key + '">' +
        '<div class="ci__img">' + img + '</div>' +
        '<div class="ci__main">' +
          '<div class="ci__name">' + esc(item.product_title) + '</div>' +
          (item.variant_title ? '<div class="ci__unit">' + esc(item.variant_title) + '</div>' : '') +
          '<div class="ci__row">' +
            '<div class="qty">' +
              '<button data-dec="' + item.key + '" aria-label="Minder"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><use href="#i-minus"/></svg></button>' +
              '<span>' + item.quantity + '</span>' +
              '<button data-inc="' + item.key + '" aria-label="Meer"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><use href="#i-plus"/></svg></button>' +
            '</div>' +
            '<div class="ci__prices">' +
              '<span class="ci__price">' + euro(linePrice) + '</span>' +
              '<span class="ci__incl">' + euro(inclVat(linePrice)) + ' incl. btw</span>' +
            '</div>' +
          '</div>' +
          '<button class="ci__remove" data-rm="' + item.key + '">Verwijderen</button>' +
        '</div></div>';
    }).join('');

    // Btw-opbouw: subtotaal + verzending (excl.) -> btw -> totaal incl.
    var subCents   = cart.total_price;
    var taxCents   = Math.round((subCents + SHIP_CENTS) * VAT_RATE);
    var totalCents = subCents + SHIP_CENTS + taxCents;
    if (cartSub)      cartSub.textContent      = euro(subCents);
    if (cartShipCost) cartShipCost.textContent = euro(SHIP_CENTS);
    if (cartTax)      cartTax.textContent      = euro(taxCents);
    if (cartTotal)    cartTotal.textContent    = euro(totalCents);

    // Gratis-verzending-balk (niet meer in gebruik sinds 11 sep, elementen bestaan niet)
    var totalEur = cart.total_price / 100;
    var pct = Math.min(100, (totalEur / FREE) * 100);
    if (cartBar) cartBar.style.width = pct + '%';
    if (cartShip) {
      cartShip.innerHTML = totalEur >= FREE
        ? '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><use href="#i-truck"/></svg> <strong>Gratis verzending</strong> van toepassing!'
        : '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><use href="#i-truck"/></svg> Nog <strong style="margin:0 4px">' + euro((FREE - totalEur) * 100) + '</strong> tot gratis verzending.';
    }
  }

  function changeQty(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  function addToCart(variantId, title, qty) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty || 1 })
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      if (data.status) { showToast(data.description || 'Kon niet toevoegen'); return; }
      showToast((title || data.product_title) + ' toegevoegd');
      refreshCart();
      openCart();
    })
    .catch(function () { showToast('Er ging iets mis. Probeer opnieuw.'); });
  }

  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest('.add-btn[data-variant-id]');
    if (addBtn && !addBtn.disabled) { addToCart(addBtn.dataset.variantId, addBtn.dataset.productTitle, 1); return; }

    var sub = e.target.closest('#productForm [type="submit"]');
    if (sub) {
      e.preventDefault();
      var form = sub.closest('#productForm');
      var id   = form && form.querySelector('#productVariantId,[name="id"]');
      var qty  = form && form.querySelector('#qtyInput,[name="quantity"]');
      if (id) addToCart(id.value, null, qty ? parseInt(qty.value) || 1 : 1);
      return;
    }

    var inc = e.target.closest('[data-inc]');
    if (inc) { var r1 = inc.closest('.ci'); var q1 = r1 && r1.querySelector('.qty span'); changeQty(inc.dataset.inc, (q1 ? parseInt(q1.textContent) : 1) + 1); return; }
    var dec = e.target.closest('[data-dec]');
    if (dec) { var r2 = dec.closest('.ci'); var q2 = r2 && r2.querySelector('.qty span'); changeQty(dec.dataset.dec, Math.max(0, (q2 ? parseInt(q2.textContent) : 1) - 1)); return; }
    var rm  = e.target.closest('[data-rm]');
    if (rm)  { changeQty(rm.dataset.rm, 0); return; }

    var fav = e.target.closest('.card__fav');
    if (fav) {
      var wl = window.hofmanWishlist;
      var h = wl ? wl.handleFor(fav) : null;
      if (wl && h) {
        var erin = wl.toggle(h);
        fav.classList.toggle('is-on', erin);
        showToast(erin ? 'Toegevoegd aan je verlanglijst ♥' : 'Verwijderd uit je verlanglijst');
      } else fav.classList.toggle('is-on');
      return;
    }
  });

  // Initiële cart count
  fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
    if (cartCount) { cartCount.textContent = c.item_count; cartCount.classList.toggle('is-visible', c.item_count > 0); }
  }).catch(function () {});

  /* ----------------------------------------------------------
     PRODUCT PAGE - qty stepper
  ---------------------------------------------------------- */
  var qtyMinus   = qs('#qtyMinus');
  var qtyPlus    = qs('#qtyPlus');
  var qtyDisplay = qs('#qtyDisplay');
  var qtyInput   = qs('#qtyInput');
  var qty = 1;
  if (qtyMinus) qtyMinus.addEventListener('click', function () { if (qty > 1) { qty--; if(qtyDisplay) qtyDisplay.textContent = qty; if(qtyInput) qtyInput.value = qty; } });
  if (qtyPlus)  qtyPlus.addEventListener('click',  function () { qty++; if(qtyDisplay) qtyDisplay.textContent = qty; if(qtyInput) qtyInput.value = qty; });

  qsa('.product-page__thumb').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var main = qs('#productMainImg');
      if (main) main.src = btn.dataset.src;
      qsa('.product-page__thumb').forEach(function (t) { t.classList.remove('is-active'); });
      btn.classList.add('is-active');
    });
  });

  document.addEventListener('click', function (e) {
    var sw = e.target.closest('.option-swatch');
    if (!sw) return;
    var group = sw.closest('.product-page__option-values');
    if (!group) return;
    qsa('.option-swatch', group).forEach(function (s) { s.classList.remove('is-active'); });
    sw.classList.add('is-active');
  });

  /* ----------------------------------------------------------
     COLLECTION FILTERS
  ---------------------------------------------------------- */
  var filterToggle  = qs('#filterToggle');
  var filterSidebar = qs('#filterSidebar');
  var filterClose   = qs('#filterClose');

  if (filterToggle && filterSidebar) {
    filterToggle.addEventListener('click', function () {
      var open = filterSidebar.classList.toggle('is-open');
      filterToggle.setAttribute('aria-expanded', String(open));
    });
  }
  if (filterClose && filterSidebar) {
    filterClose.addEventListener('click', function () {
      filterSidebar.classList.remove('is-open');
      if (filterToggle) filterToggle.setAttribute('aria-expanded', 'false');
    });
  }

  // Filter checkboxes — gedelegeerd (change bubbelt)
  document.addEventListener('change', function (e) {
    var cb = e.target.closest('.filter-check');
    if (!cb || !cb.dataset.param) return;
    var url   = new URL(window.location.href);
    var param = cb.dataset.param;
    var val   = cb.dataset.value;
    var vals  = url.searchParams.getAll(param).filter(Boolean);
    if (cb.checked) { if (!vals.includes(val)) vals.push(val); }
    else { vals = vals.filter(function (v) { return v !== val; }); }
    url.searchParams.delete(param);
    vals.forEach(function (v) { url.searchParams.append(param, v); });
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  var priceForm = qs('#priceFilterForm');
  if (priceForm) {
    priceForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var url = new URL(window.location.href);
      var min = priceForm.querySelector('[name="filter.v.price.gte"]');
      var max = priceForm.querySelector('[name="filter.v.price.lte"]');
      if (min && min.value) url.searchParams.set('filter.v.price.gte', min.value);
      else url.searchParams.delete('filter.v.price.gte');
      if (max && max.value) url.searchParams.set('filter.v.price.lte', max.value);
      else url.searchParams.delete('filter.v.price.lte');
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  // Filter accordeon — gedelegeerd op document zodat de binding nooit verloren gaat
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.filter-group__head');
    if (!btn) return;
    var expanded = btn.getAttribute('aria-expanded') !== 'false';
    var body = qs('#' + btn.getAttribute('aria-controls'));
    btn.setAttribute('aria-expanded', String(!expanded));
    if (body) body.hidden = expanded;
  });

})();

/* ============================================================
   Verlanglijst (localStorage) — hartjes bewaren + header-teller
   ============================================================ */
(function () {
  var KEY = 'hofman_wishlist';
  function get() { try { var v = JSON.parse(localStorage.getItem(KEY)); return Array.isArray(v) ? v : []; } catch (e) { return []; } }
  function set(list) { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} badge(); }
  function badge() {
    var n = get().length;
    document.querySelectorAll('.wish-count').forEach(function (b) {
      b.textContent = n;
      b.classList.toggle('is-visible', n > 0);
    });
  }
  function handleFor(el) {
    if (el.dataset && el.dataset.handle) return el.dataset.handle;
    var card = el.closest('article, .card');
    var a = card && card.querySelector('a[href*="/products/"]');
    var m = a && a.getAttribute('href').match(/\/products\/([a-z0-9\-]+)/);
    return m ? m[1] : null;
  }
  function toggle(h) {
    var list = get();
    var i = list.indexOf(h);
    if (i >= 0) list.splice(i, 1); else list.push(h);
    set(list);
    return list.indexOf(h) >= 0;
  }
  function mark() {
    var list = get();
    document.querySelectorAll('.card__fav').forEach(function (btn) {
      var h = handleFor(btn);
      if (h) btn.classList.toggle('is-on', list.indexOf(h) >= 0);
    });
    badge();
  }
  window.hofmanWishlist = { get: get, set: set, toggle: toggle, handleFor: handleFor, mark: mark, badge: badge };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mark);
  else mark();
})();
